module.exports = __webpack_public_path__ + "fonts/fc97b9dc5bc4b980b2d6f4c9ec30dfd0.txt";